import { setPermissions } from './utils'

export const setExportData = ({ agentPermissions }) => {
    const result = setPermissions(agentPermissions, 'feature.export')

    return {
        hasPermission: result === 'all' || result === 'category',
        canExportAll: result === 'all',
    }
}
